import { jsPDF } from 'jspdf'
import 'jspdf-autotable'
import utils from '@/mixins/utils.js'
import store from '@/store/store'
import { api, apiPublic } from '@/plugins/axios.js'
import { vue } from '@/main.js'

// Retorna os cadastros
/**
 * @param {int} cod_ibge - IBGE do município
 * @param {int} nu_ine - INE da Equipe
 */
export async function getDados(cod_ibge, nu_cnes, mes, ano) {
  try {
    const { data } = await api.get(
      '/app/bpa-i/' +
        cod_ibge +
        '/' +
        nu_cnes +
        '/' +
        mes +
        '-' +
        ano +
        '/' +
        '12'
    )
    return data
  } catch (err) {
    console.log(err)
  }
}
export async function getProfissionais(cod_ibge, nu_cnes) {
  try {
    const { data } = await api.get(
      `/app/profissionais/${cod_ibge}/cnes/${nu_cnes}`
    )
    return data
  } catch (err) {
    console.log(err)
  }
}

export function generatePdf(
  cadastros,
  cod_ibge,
  nu_cnes,
  mes,
  ano,
  profissional = null
) {
  let title_pdf = 'BPA-I'
  let titlePdfSave = `bpa_i-${mes}-${ano}-${nu_cnes}-${profissional.nu_cns}`
  let description_pdf = 'Procedimentos Ambulatoriais Individualizados'
  let headers_pdf = ['']

  var data_pdf = []
  for (let i = 0; i < cadastros.length; i++) {
    var obj = {}

    let cns = cadastros[i].cns || '                '
    let no_cidadao = cadastros[i].no_cidadao || '                '
    let sexo = cadastros[i].sexo || '                '
    let dt_nascimento =
      utils.methods.formatDate(cadastros[i].dt_nascimento) || '                '
    let nacionalidade =
      cadastros[i].nacionalidade || '____________________________'
    let raca_cor = cadastros[i].raca_cor || '_________________'
    let etnia = cadastros[i].etnia || '_________________'
    let ddd = cadastros[i].ddd || '_______'
    let telefone = cadastros[i].telefone || '___________________'
    let email = cadastros[i].email || '_______________________________________'
    let cep = cadastros[i].cep || '                '
    let ibge = profissional.co_ibge
    let endereco = `${cadastros[i].tipo_logradouro || '   '} ${
      cadastros[i].logradouro || '   '
    } ${
      cadastros[i].complemento != null ? `, ${cadastros[i].complemento}` : ''
    }, ${cadastros[i].bairro || '   '}`
    let dt_procedimento = utils.methods.formatDate(cadastros[i].dt_procedimento)
    let procedimento = cadastros[i].procedimento

    obj.dados = `    CNS PACIENTE: ${cns}       PACIENTE: ${no_cidadao}\n
    SEXO: ${sexo}       NASCIMENTO: ${dt_nascimento}       NACIONALIDADE: ${nacionalidade}       RAÇA/COR: ${raca_cor}       ETNIA: ${etnia} \n
    CEP: ${cep}       IBGE: ${ibge}       ENDEREÇO: ${endereco}\n
    DDD:${ddd}       TELEFONE DE CONTATO: ${telefone}       E-MAIL: ${email}\n
    DATA DO PROCEDIMENTO: ${dt_procedimento}       CÓDIGO DO PROCEDIMENTO: ${procedimento}       QTDE:____       CNPJ:____________________________ \n
    SERVIÇO:_______        CLASS:_______        CID:________       CARÁTER DE ATENDIMENTO:____________________________        Nº DA AUTORIZAÇÃO:_______`

    data_pdf.push(obj)
  }

  let doc = new jsPDF(utils.methods.encryptionPdf())
  // cria a tabela
  let table = utils.methods.createTablePdf(data_pdf)

  utils.methods
    .fileToBase64(store.state.infoMunicipio.brasao)
    .then((base64data) => {
      // Header
      let verticalPosition = utils.methods.headerPdf(
        doc,
        base64data,
        title_pdf,
        description_pdf
      )

      const pageWidth = doc.internal.pageSize.getWidth()
      const marginXtext = pageWidth / 2

      doc.text(
        `IDENTIFICAÇÃO DO PROFISSIONAL`,
        marginXtext,
        verticalPosition,
        null,
        null,
        'center'
      )
      verticalPosition += 12

      // Data atual
      let data = new Date()
      let dia = String(data.getDate()).padStart(2, '0')
      let mesAtual = String(data.getMonth() + 1).padStart(2, '0')
      let anoAtual = data.getFullYear()
      let dataAtual = dia + '/' + mesAtual + '/' + anoAtual

      doc.text(
        `CNS: ${profissional.nu_cns}    PROFISSIONAL: ${profissional.no_profissional}\nCBO: ${profissional.co_cbo}    MÊS/ANO: ${mes}/${ano}    CNES: ${nu_cnes}\nDATA: ${dataAtual}`,
        15,
        verticalPosition,
        null,
        null,
        'left'
      )
      verticalPosition += 16

      doc.autoTable({
        head: [headers_pdf],
        body: table,
        headStyles: {
          fillColor: '#ccc',
          fontSize: 6,
          textColor: '#000',
          halign: 'center',
          cellWidth: 'wrap',
        },
        bodyStyles: {
          halign: 'left',
          fontSize: 6,
        },
        theme: 'striped',
        startY: verticalPosition,
        showHead: 'firstPage',
      })

      utils.methods.footerPdf(doc, doc.autoTable.previous.finalY)

      doc.save(titlePdfSave + '.pdf')

      vue.$toast.success('PDF GERADO COM SUCESSO!', 'Sucesso:', {
        position: 'topRight',
      })
    })
    .catch((error) => {
      console.error(error)
      vue.$toast.error('ERRO AO GERAR PDF!', 'Erro:', {
        position: 'topRight',
      })
    })
}

export const dataFields = {
  Nome: 'no_cidadao',
  'Data de nascimento': {
    field: 'dt_nascimento',
    callback: (value) => {
      return value !== '' ? utils.methods.formatDate(value) : ''
    },
  },
  Mãe: 'no_mae',
  MA: 'micro_area',
}
